export enum AdminAnalyticsTypes {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  YEAR = 'YEAR',
  LIFETIME = 'LIFETIME',
  ALL = 'ALL',
  RANGE = 'RANGE',
  CUSTOM = 'CUSTOM',
}

export type DataPoint = {
  label: string;
  value: number;
};

export interface AnalyticsFilter<T extends AdminAnalyticsTypes> {
  filter: T;
  range?: Date[];
  offset?: number;
  dir?: number;
  search?: string;
  orderKey?: string;
}

export type AnalyticsOverviewModels = DataPoint[];
